import PropTypes from "prop-types";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { WarningAmber } from "@mui/icons-material";
export default function ResetAllConfirmationDialog({
  open,
  onClose,
  onConfirm,
  switches,
  resetAllLoading,
}) {
  const affected = switches.filter((group) => group.activePorts > 0),
    count = affected.reduce((n, group) => n + group.activePorts, 0);
  return (
    <Dialog
      open={open}
      onClose={resetAllLoading ? undefined : onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="reset-all-dialog-title"
      PaperProps={{ sx: { borderRadius: 3, maxHeight: "92vh" } }}
    >
      <DialogTitle
        component="div"
        sx={{ display: "flex", alignItems: "center", gap: 1.5, bgcolor: "#193e54", px: 3, py: 2 }}
      >
        <WarningAmber sx={{ color: "#ffd28a" }} />
        <Typography
          id="reset-all-dialog-title"
          component="h2"
          sx={{ color: "#fff", fontSize: "1rem", fontWeight: 700 }}
        >
          Confirmar reinicio masivo global
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Alert severity="warning" sx={{ my: 2 }}>
          Esta solicitud incluye {count} puertos de {affected.length} switches. La búsqueda no
          limita su alcance. Los dispositivos conectados pueden perder conectividad durante el
          reinicio.
        </Alert>
        <Typography sx={{ fontSize: ".85rem", fontWeight: 600, color: "#243b53", mb: 1.5 }}>
          Puertos con reinicio automático habilitado
        </Typography>
        <TableContainer
          sx={{
            maxHeight: "40vh",
            border: "1px solid #dce5ed",
            borderRadius: 2,
            boxShadow: "none",
          }}
        >
          <Table stickyHeader size="small" aria-label="Alcance global del reinicio">
            <TableHead sx={{ display: "table-header-group", p: 0 }}>
              <TableRow>
                {["Switch", "IP", "Puertos incluidos"].map((text) => (
                  <TableCell
                    key={text}
                    sx={{ bgcolor: "#eef3f8", color: "#526579", fontWeight: 700 }}
                  >
                    {text}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {affected.map((group) => (
                <TableRow key={group.id}>
                  <TableCell sx={{ fontSize: ".8rem" }}>{group.name.replace(/_/g, " ")}</TableCell>
                  <TableCell sx={{ fontSize: ".8rem", fontFamily: "monospace" }}>
                    {group.ip}
                  </TableCell>
                  <TableCell sx={{ fontSize: ".8rem" }}>
                    {group.ports
                      .filter((p) => p.resetstatus)
                      .map((p) => p.port)
                      .join(", ")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography sx={{ fontSize: ".75rem", color: "#526579", mt: 2 }}>
          Los puertos con el reinicio automático deshabilitado no se incluyen en esta solicitud.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #dce5ed", gap: 1 }}>
        <Button onClick={onClose} disabled={resetAllLoading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={onConfirm}
          disabled={resetAllLoading || count === 0}
        >
          {resetAllLoading ? "Procesando…" : `Solicitar reinicio de ${count} puertos`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
ResetAllConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  switches: PropTypes.array.isRequired,
  resetAllLoading: PropTypes.bool,
};
